module.exports = __webpack_public_path__ + "static/media/image3.980d8a53.png";